import React, { forwardRef, InputHTMLAttributes, useImperativeHandle, useRef } from 'react';
import cn from 'classnames';

import Button, { ButtonStyleType } from '../Button/Button';
import Input from '@/components/common/Input/Input';
import styles from './FileInput.module.scss';

interface IFileInput extends InputHTMLAttributes<HTMLInputElement> {
  format?: string;
  className?: string;
}

const FileInput = forwardRef((props: IFileInput, ref: any) => {
  const { className, format, disabled, id, ...restProps } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  useImperativeHandle(ref, () => inputRef.current);

  const classNameString = cn(
    styles.fileUpload, className
  );

  const onClickButton = () => {
    inputRef.current?.click();
  };

  return (
    <div className={classNameString}>
      <Input
        ref={inputRef}
        type="file"
        className={styles.fileInput}
        accept={format ?? undefined}
        disabled={disabled}
        {...restProps}
      />
      <div className={styles.fileInputBtn}>
        <Button
          buttonStyleType={ButtonStyleType.PRIMARY}
          disabled={disabled}
          buttonSize="small"
          onClick={onClickButton}
        >
          Choose file
        </Button>
      </div>
    </div>
  );
});

export default FileInput;